(function () {
  'use strict';

  // Bridges the custom buy-box ATC form to the theme's native cart-drawer.
  // The buy box uses a plain {% form 'product' %} (not <product-form>), so
  // without this the submit does a full-page POST -> /cart redirect. When a
  // <cart-drawer> is present (settings.cart_type == 'drawer') we intercept,
  // add via AJAX and open the drawer — the customer stays on the page.
  // No-op (native submit) when no cart-drawer exists.

  function getDrawer() { return document.querySelector('cart-drawer'); }

  function onSubmit(form, evt) {
    var cart = getDrawer();
    if (!cart || typeof cart.renderContents !== 'function') return; // native fallback
    evt.preventDefault();
    if (form.dataset.atcDrawerBusy) return;
    form.dataset.atcDrawerBusy = '1';

    // Immediate feedback: the styled spinner (.t-buybox__atc[data-loading="1"])
    // bridges the /cart/add roundtrip until the drawer slides in.
    var btn = form.querySelector('[data-atc-button]');
    if (btn) btn.setAttribute('data-loading', '1');

    var formData = new FormData(form);
    var ids = cart.getSectionsToRender().map(function (s) { return s.id; });
    formData.append('sections', ids.join(','));
    formData.append('sections_url', window.location.pathname);
    if (typeof cart.setActiveElement === 'function') {
      cart.setActiveElement(btn || document.activeElement);
    }

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.status) {
          // sold-out / inventory race → safe fallback: show the cart page
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-atc-drawer',
              productVariantId: formData.get('id'),
              errors: data.errors || data.description,
              message: data.message
            });
          }
          window.location = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-atc-drawer',
            productVariantId: formData.get('id'),
            cartData: data
          });
        }
        // Cart is non-empty after a successful add. The native renderContents()
        // only clears is-empty on .drawer__inner (a no-op — the class lives on
        // <cart-drawer> itself), so a stale page-load is-empty would keep the
        // empty-state layout: line items hidden + trapFocus crash (looks for the
        // now-absent .drawer__inner-empty). Clear it on the element before render/open.
        cart.classList.remove('is-empty');
        cart.renderContents(data); // updates #CartDrawer + #cart-icon-bubble, then open()
      })
      .catch(function () {
        form.dataset.atcDrawerBusy = '';
        form.submit(); // network failure → don't strand the customer
      })
      .finally(function () {
        form.dataset.atcDrawerBusy = '';
        if (btn) btn.removeAttribute('data-loading');
      });
  }

  function bind() {
    document.querySelectorAll('[data-product-form] [data-atc-button]').forEach(function (btn) {
      var form = btn.closest('form');
      if (!form || form.dataset.atcDrawerBound) return;
      form.dataset.atcDrawerBound = '1';
      form.addEventListener('submit', function (evt) { onSubmit(form, evt); });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
})();
